import { render, staticRenderFns } from "./titles.vue?vue&type=template&id=a39c4db0"
import script from "./titles.vue?vue&type=script&lang=js"
export * from "./titles.vue?vue&type=script&lang=js"
import style0 from "./titles.vue?vue&type=style&index=0&id=a39c4db0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports